<template>
  <div class="header__title">
    <router-link
      v-if="route.meta.back"
      custom
      v-slot="{ navigate }"
      :to="{ name: route.meta.back.toString() }"
    >
      <PhArrowLeft @click="navigate" title="Retour à la page précédente" />
    </router-link>
    <PhArrowsClockwise title="Actualiser la page" @click="reload" />

    <span v-if="route.meta.title">{{ route.meta.title }}</span>
  </div>
</template>

<script setup lang="ts">
import { PhArrowLeft, PhArrowsClockwise } from '@phosphor-icons/vue'
import { useRoute } from 'vue-router'

const route = useRoute()

function reload() {
  location.reload()
}
</script>
